import React from 'react'

const LogosContext = React.createContext({})
export const LogosProvider = LogosContext.Provider
export default LogosContext
